import type { FC, ReactNode } from 'react';
import {
  AlertTriangle,
  CheckCircle2,
  Info,
  XCircle,
} from 'lucide-react';

export type IpcAlertTone = 'success' | 'warning' | 'destructive' | 'info';

type Props = {
  tone?: IpcAlertTone;
  title: ReactNode;
  description?: ReactNode;
  className?: string;
};

const ICONS: Record<IpcAlertTone, typeof CheckCircle2> = {
  success: CheckCircle2,
  warning: AlertTriangle,
  destructive: XCircle,
  info: Info,
};

/** Showcase §7 Alert 横幅 */
export const IpcAlert: FC<Props> = ({ tone = 'info', title, description, className }) => {
  const Icon = ICONS[tone];
  return (
    <div
      className={['ipc-alert', `ipc-alert--${tone}`, className].filter(Boolean).join(' ')}
      role="alert"
    >
      <Icon className="ipc-alert__icon" size={16} aria-hidden />
      <div className="ipc-alert__body">
        <p className="ipc-alert__title">{title}</p>
        {description != null && description !== '' && (
          <p className="ipc-alert__desc">{description}</p>
        )}
      </div>
    </div>
  );
};
